import React from "react";
import styles from "./style.module.css";
import EventsCard from "../EventsCard";
const Events = () => {
  return (
    <div className={styles.container}>
      <div className={styles.headingContainer}>
        <h3>Don’t miss out on exciting 450+ free events</h3>
        <p>
          Explore What's Happening! Discover a vibrant array of events happening
          in our community. From workshops to social gatherings, there's
          something for everyone. Join us and be part of the excitement !
        </p>
      </div>

      <EventsCard />
    </div>
  );
};

export default Events;
